import TextArea from "antd/es/input/TextArea"
import MyInput from "../../../components/ui/MyInput"
import { Dropdown } from "primereact/dropdown"
import { useEffect, useState } from "react"
import { validateHttps } from "../../../helper/Validators"
const Links = ({ linksFormButtonRef, data, setData, onSave }) => {
    const initialLinksData = {
        supportUrl: "",
        privacyPolicyUrl: "",
        storeUrl: ""
    }
    const [linksData, setLinksData] = useState(initialLinksData)

    const updateAppDetails = (key, value) => {
        setLinksData((state) => ({ ...state, [key]: value }))
    }
    useEffect(() => {

        const newLinkData = { ...initialLinksData }
        Object.keys(data).map(key => {
            if (key in initialLinksData && data[key]) {
                newLinkData[key] = data[key]
            }
        })

        setLinksData(newLinkData)
    }, [])

    return (
        <form className="flex flex-col gap-[20px] items-center p-[20px] "
            onSubmit={(e) => {
                e.preventDefault()
                e.stopPropagation()
                setData(state => ({ ...state, ...linksData }))
                onSave()
            }}
        >
            <div className="w-[1050px] flex flex-row justify-between">
                <div className="w-[500px]">
                    <MyInput value={linksData.supportUrl} onChange={(e) => (updateAppDetails("supportUrl", validateHttps(e)))} isRequired={true} label={"Destek Bağlantısı"} placeholder="Uygulama mağazalarında görünmesi için bir iletişim sayfası linki giriniz." />

                </div>
                <div className="w-[500px]">

                    <MyInput value={linksData.privacyPolicyUrl} onChange={(e) => (updateAppDetails("privacyPolicyUrl", validateHttps(e)))} isRequired={true} label={"Gizlilik Sözleşmesi Bağlantısı"} placeholder="Uygulama mağazalarında görünecek gizlilik sözleşmesi sayfasının linkini giriniz." />
                </div>

            </div>
            <div className="w-[1050px] flex flex-row justify-between">
                <div className="w-[500px]">

                    <MyInput value={linksData.storeUrl} onChange={(e) => (updateAppDetails("storeUrl", validateHttps(e)))} isRequired={true} label={"Mağaza Website Adresi"} placeholder="Uygulama mağazalarında görünmesi için bir iletişim sayfası linki giriniz." />
                </div>

            </div>

            <button className="hidden" ref={linksFormButtonRef} type="submit" ></button>
        </form>
    )
}

export default Links
